import './assets/styles/main.css'
import App from './App.vue'

import { createApp } from 'vue'
import { register } from './services'
import { register as plugins } from './plugins'
import { useSnackBar } from './stores/snackbar'
import { useDialog } from './stores/dialog'
import { useLoader } from './stores/loader'

const app = createApp(App)

app.use(plugins)
register(app)

app.config.globalProperties.$snackbar = useSnackBar()
app.config.globalProperties.$dialog = useDialog()
app.config.globalProperties.$loader = useLoader()

app.mount('#app')
